export default "__VITE_ASSET__DxxJSTHa__"